module.exports = __webpack_public_path__ + "img/BACKGROUND_ECO_EMP.f8070299.jpg";